import React from 'react';

const Loader = () => {
  return (
    <div className="loader">
      <img src={require('../assets/images/icons/loader.gif')} alt="loader" />
    </div>
  );
};

export default Loader;
